import api from "services/api";

const submitChatbotAnswer = (answerObj) => {
   return api
            .post("/chatbot/atributos_cliente", answerObj)
}

export default submitChatbotAnswer;
